var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirPress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@1xAir_Pressure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Air_Pressure",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 1)",
    fill: "#1991DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.28,0 30,6.72 30,15 C30,23.28 23.28,30 15,30 C6.72,30 0,23.28 0,15 C0,6.72 6.72,0 15,0 Z M15,26.8 C21.5195,26.8 26.8,21.5195 26.8,15 C26.8,8.4805 21.5195,3.2 15,3.2 C8.4805,3.2 3.2,8.4805 3.2,15 C3.2,21.5195 8.4805,26.8 15,26.8 Z M15.975,15.2 L15.975,20.8 L14.225,20.8 L14.225,15.2 L11.6,15.2 L15.1,9.6 L18.6,15.2 L15.975,15.2 Z M15,6 C15.5522847,6 16,5.55228475 16,5 C16,4.44771525 15.5522847,4 15,4 C14.4477153,4 14,4.44771525 14,5 C14,5.55228475 14.4477153,6 15,6 Z M19,7 C19.5522847,7 20,6.55228475 20,6 C20,5.44771525 19.5522847,5 19,5 C18.4477153,5 18,5.44771525 18,6 C18,6.55228475 18.4477153,7 19,7 Z M11,7 C11.5522847,7 12,6.55228475 12,6 C12,5.44771525 11.5522847,5 11,5 C10.4477153,5 10,5.44771525 10,6 C10,6.55228475 10.4477153,7 11,7 Z M8,9 C8.55228475,9 9,8.55228475 9,8 C9,7.44771525 8.55228475,7 8,7 C7.44771525,7 7,7.44771525 7,8 C7,8.55228475 7.44771525,9 8,9 Z M22,9 C22.5522847,9 23,8.55228475 23,8 C23,7.44771525 22.5522847,7 22,7 C21.4477153,7 21,7.44771525 21,8 C21,8.55228475 21.4477153,9 22,9 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirPress);
export default __webpack_public_path__ + "static/media/AirPress.9c6873d226036234f71cf2def255ce00.svg";
export { ForwardRef as ReactComponent };